'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n'], ['\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n  padding: 0 9px 18px 9px;\n  flex-basis: ', '%;\n  max-width: ', '%;\n  height: ', ';\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  position: relative;\n  padding: 0 9px 18px 9px;\n  flex-basis: ', '%;\n  max-width: ', '%;\n  height: ', ';\n  ', '\n\n  ', '\n\n  ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    flex-basis: 33.3333%;\n    max-width: 33.33333%;\n  '], ['\n    flex-basis: 33.3333%;\n    max-width: 33.33333%;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    flex-basis: 50%;\n    max-width: 50%;\n    padding: 0 5px 12px 5px;\n  '], ['\n    flex-basis: 50%;\n    max-width: 50%;\n    padding: 0 5px 12px 5px;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var transitionIn = (0, _styledComponents.keyframes)(_templateObject);

var Grid = _styledComponents2.default.div(_templateObject2, function (props) {
  return 100 / props.grid;
}, function (props) {
  return 100 / props.grid;
}, function (props) {
  return props.height || 'auto';
}, (0, _helpers.boolStyle)('noPadding', 'padding: 0 9px 9px 9px;'), function (props) {
  return props.square && '\n    padding: 0;\n    &:before {\n      content: \'\';\n      display: block;\n      padding-top: 100%;\n    }';
}, function (props) {
  return props.transition && '\n    opacity: 0;\n    transform: translateY(50px);\n    animation-name: ' + transitionIn + ';\n    animation-duration: ' + props.transitionDuration + 'ms;\n    animation-delay: ' + props.transitionDelay + 'ms;\n    animation-fill-mode: forwards;\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  ';
});

Grid.displayName = 'Grid';
var MobileGrid = Grid.extend(_templateObject3, _helpers.media.mobileTablet(_templateObject4), _helpers.media.mobile(_templateObject5));

var NitroGrid = function NitroGrid(_ref) {
  var grid = _ref.grid,
      square = _ref.square,
      children = _ref.children,
      noPadding = _ref.noPadding,
      props = _objectWithoutProperties(_ref, ['grid', 'square', 'children', 'noPadding']);

  var GridComponent = grid > 1 ? MobileGrid : Grid;

  return _react2.default.createElement(
    GridComponent,
    _extends({
      grid: grid,
      square: square
    }, props, {
      noPadding: noPadding
    }),
    children
  );
};

NitroGrid.defaultProps = {
  grid: 1,
  noPadding: false
};

NitroGrid.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  grid: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.string,
  noPadding: _propTypes2.default.bool,
  square: _propTypes2.default.bool
};

exports.default = NitroGrid;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-grid/NitroGrid.js
// module id = 2909
// module chunks = 4